import React from "react";
import { Main } from "./Main";
import { Navbar } from "./navbar/Navbar";

export const Home = () => {
    return(
        <><Navbar />
        <Main />
        </>
    )
}